import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { Comment as CommentType } from '@utils/backend-api/comments';

import IconStar from '../../Images/Rebranding/IconStar';
import TimeAgo from '../../TimeAgo';
import CommentHeader from './Header';

export default function CommentContent({ comment }: { comment: CommentType }) {
  const { user, is_anonymous } = comment;
  return (
    <>
      <CommentHeader user={user} isAnonymous={is_anonymous} />
      <div className="ml-0 sm:ml-72">
        {comment.promoted && (
          <div className="group relative mb-4 inline-block cursor-pointer items-center text-primary-magenta hover:text-primary-pink">
            <IconStar className="mr-8 h-16 w-16 align-middle" />
            <span className="font-suisse-screen text-byline-sm">promoted</span>
            <p className="absolute m-0 hidden w-[180px] bg-grayscale-charcoal p-12 font-suisse-intl text-body-sm font-light text-white group-hover:block">
              Our staff has promoted this comment because it is great!
            </p>
          </div>
        )}
        <div className="font-suisse-intl text-button-md text-black">
          {ReactHtmlParser(comment.body)}
        </div>
      </div>

      {!!comment.edited_at && (
        <div className="ml-72 text-disclosure-sm text-grayscale-gray">
          Edited <TimeAgo date={comment.edited_at} timeFromNow />
        </div>
      )}
    </>
  );
}
